module.exports = __webpack_public_path__ + "img/declaration.e4e6179d.png";